module.exports = "/assets/data/f122168fb9c15e54b70283a4f607f49e-AB32.data.json";